module.exports = __webpack_public_path__ + "static/media/rain-drop.649b4853.svg";